// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/31803
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 31803 
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils'
interface IExpoTrackParamsRecord {
  /** Bind ochama card Exp */
Bind_ochama_card_Exp: undefined
  /** Bind ochama Card Link button */
Bind_Ochama_Link_Button_Exp: undefined
  /** Bind ochama card dismiss */
Bind_Ochama_Card_Dismiss_button_Exp: undefined
  /** Account link ochama */
Account_Linkochama_Exp: undefined
  /** ochama default page upgrade */
Upgrade_button_Exp: undefined
  /** ochama default page order */
Manage_Button_Exp: undefined
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** Bind ochama card Exp */
  Bind_ochama_card_Exp:'Bind_ochama_card_Exp',
/** Bind ochama Card Link button */
  Bind_Ochama_Link_Button_Exp:'Bind_Ochama_Link_Button_Exp',
/** Bind ochama card dismiss */
  Bind_Ochama_Card_Dismiss_button_Exp:'Bind_Ochama_Card_Dismiss_button_Exp',
/** Account link ochama */
  Account_Linkochama_Exp:'Account_Linkochama_Exp',
/** ochama default page upgrade */
  Upgrade_button_Exp:'Upgrade_button_Exp',
/** ochama default page order */
  Manage_Button_Exp:'Manage_Button_Exp',
})

interface IClickTrackParamsRecord {
  /** Bind ochama card link button */
Bind_Ochama_Card_Link_Button_Click: undefined
  /** Bind ochama card dismiss button */
Bind_Ochama_Card_Dismiss_Button_Click: undefined
  /** ochama default page upgrade */
Upgrade_Button_Click: undefined
  /** ochama default page order */
Manage_Order_Click: undefined
  /** Account link ochama */
Account_Link_ochama_Click: {
/** 按钮名称展示类型 1-等待预约,2-立即预约,3-已预约,4-等待抢购,5-抢购中 */
btnShowType: | '1'| '2'| '3'| '4'| '5'}
}

const sendClickTrack = {
  /** 点击事件上报-Bind ochama card link button */
Bind_Ochama_Card_Link_Button_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Bind_Ochama_Card_Link_Button_Click'});
  },
  /** 点击事件上报-Bind ochama card dismiss button */
Bind_Ochama_Card_Dismiss_Button_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Bind_Ochama_Card_Dismiss_Button_Click'});
  },
  /** 点击事件上报-ochama default page upgrade */
Upgrade_Button_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Upgrade_Button_Click'});
  },
  /** 点击事件上报-ochama default page order */
Manage_Order_Click: () => {
    eventTrackingUtils.submitCL({event_id:'Manage_Order_Click'});
  },
  /** 点击事件上报-Account link ochama */
Account_Link_ochama_Click: (json_param: IClickTrackParamsRecord['Account_Link_ochama_Click']) => {
    eventTrackingUtils.submitCL({event_id:'Account_Link_ochama_Click',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
}
export type {
  IExpoTrackParamsRecord,
}